<div class="pendencia-toast" role="alert">
  <span class="pendencia-toast-icone" aria-hidden="true"><i class='bx bx-task'></i></span>

  <div class="pendencia-toast-corpo">
    <span class="pendencia-toast-frase" *ngIf="title">{{ title }}</span>
    <strong class="pendencia-toast-titulo" *ngIf="message">{{ message }}</strong>
    <span class="pendencia-toast-acao">Clique aqui para ver a pendência <i class='bx bx-right-arrow-alt'></i></span>
  </div>

  <button *ngIf="options.closeButton" type="button" class="pendencia-toast-fechar"
          (click)="fechar($event)" title="Fechar" aria-label="Fechar">
    <i class='bx bx-x'></i>
  </button>
</div>
